/* eslint-disable */
/// This file is auto generated - do not edit manually
export const SkinTestTitle = 'Website.Questionnaire.SkinTest.SkinTestTitle';
export const GetRecommendations = 'Website.Questionnaire.SkinTest.GetRecommendations';
export const SidebarHeadline = 'Website.Questionnaire.SkinTest.SidebarHeadline';
export const SidebarText = 'Website.Questionnaire.SkinTest.SidebarText';
export const ConditionsValidation = 'Website.Questionnaire.SkinTest.ConditionsValidation';
